// extracted by mini-css-extract-plugin
export default {"wrapper":"ReassignModal_wrapper__r3Qtt","iconWrapper":"ReassignModal_iconWrapper__QByZ+","heading":"ReassignModal_heading__yDWNo","footerBtn":"ReassignModal_footerBtn__KYdUK"};